import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-envases-confeccion',
    templateUrl: './envases-confeccion.component.html'
})
export class EnvasesConfeccionComponent implements OnInit {

    public cajasEnvasePorcion = [];
    public porcionesArray = [];
    public porciones = [];
    public dropdownSection: number;

    @Input() cajasConfeccion;

    constructor(private _translate: TranslateService) {}

    ngOnInit() {
        //this.getEnvases();
    }

    private getEnvases() {
        for (let cajaConfeccion of this.cajasConfeccion[0].caja.cajasEnvasePorcionAgrupados) {
            this.cajasEnvasePorcion.push(cajaConfeccion);
        }
    }

    public showSection(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }
}
